let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9Npbc")).then(() => parcelRequire('eqxvz'));